import { render } from "./SpeakerSvg.vue?vue&type=template&id=35170c7d&ts=true"
import script from "./SpeakerSvg.vue?vue&type=script&lang=ts"
export * from "./SpeakerSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__